import React, { useState } from 'react';

const TABS = ['Status', 'Sources', 'Qualification'];

function tilesForStatus(deals) {
  const open = deals.filter((d) => ['New lead', 'Qualified'].includes(d.stage)).length;
  const inProgress = deals.filter((d) => ['Proposal', 'Negotiation'].includes(d.stage)).length;
  const lost = deals.filter((d) => d.stage === 'Lost').length;
  const won = deals.filter((d) => d.stage === 'Won').length;
  return [
    { label: 'Open', value: open, color: 'var(--text-faint)' },
    { label: 'In Progress', value: inProgress, color: 'var(--info)' },
    { label: 'Lost', value: lost, color: 'var(--fail)' },
    { label: 'Won', value: won, color: 'var(--pass)' },
  ];
}

function tilesForSources(deals) {
  const counts = {};
  deals.forEach((d) => { counts[d.source] = (counts[d.source] || 0) + 1; });
  const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]).slice(0, 4);
  const palette = ['var(--info)', 'var(--purple)', 'var(--teal)', 'var(--warn)'];
  return sorted.map(([label, value], i) => ({ label, value, color: palette[i % palette.length] }));
}

function tilesForQualification(deals) {
  const hot = deals.filter((d) => d.probability >= 70).length;
  const warm = deals.filter((d) => d.probability >= 40 && d.probability < 70).length;
  const cold = deals.filter((d) => d.probability > 0 && d.probability < 40).length;
  const unqualified = deals.filter((d) => d.probability === 0).length;
  return [
    { label: 'Hot', value: hot, color: 'var(--fail)' },
    { label: 'Warm', value: warm, color: 'var(--warn)' },
    { label: 'Cold', value: cold, color: 'var(--info)' },
    { label: 'Unqualified', value: unqualified, color: 'var(--text-faint)' },
  ];
}

export default function LeadsPanel({ deals = [] }) {
  const [tab, setTab] = useState('Status');
  const tiles = tab === 'Status' ? tilesForStatus(deals) : tab === 'Sources' ? tilesForSources(deals) : tilesForQualification(deals);
  const totalLeads = deals.length;

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <div className="card-title">Leads management</div>
          <div className="card-subtitle">{totalLeads} total leads in pipeline</div>
        </div>
        <div className="tabs">
          {TABS.map((t) => <span key={t} className={`tab-btn ${tab === t ? 'active' : ''}`} onClick={() => setTab(t)}>{t}</span>)}
        </div>
      </div>
      <div className="card-body">
        <div className="leads-mini-grid">
          {tiles.map((t) => (
            <div className="leads-mini-tile" key={t.label}>
              <span className="leads-mini-label"><span className="leads-mini-dot" style={{ background: t.color }} />{t.label}</span>
              <div className="leads-mini-value">{t.value}</div>
              <div className="leads-mini-sub">leads</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
